import BeamPersonalCommunityImpactTabs from "./beamPersonalCommunityImpactTabs";

export default BeamPersonalCommunityImpactTabs;
